import { useMemo, useRef } from 'react';

/**
 * Only the answer to the latest request may land. Switching the period, the
 * card or a filter sends a new request while the old one is still out; if
 * the old answer comes back last, it overwrote the new data with the old.
 *
 *   const latest = useLatestRequest();
 *   const ticket = latest.begin();
 *   const res = await load();
 *   if (latest.isLatest(ticket)) setData(res);
 */
export const useLatestRequest = () => {
  const seq = useRef(0);
  return useMemo(() => ({
    /** Starts a request and returns its ticket; every earlier ticket is now stale. */
    begin: (): number => {
      seq.current += 1;
      return seq.current;
    },
    /** Whether no request has started since this ticket's. */
    isLatest: (ticket: number): boolean => ticket === seq.current,
  }), []);
};
